import './lib/ReactPlayer.js';
import './lib/players/YouTube.js';
import { __exports as ReactPlayer } from '../../_virtual/ReactPlayer.js';
import { __exports as YouTube } from '../../_virtual/YouTube.js';

var createReactPlayer = ReactPlayer.createReactPlayer;
var Player = YouTube.default;
var youtube = createReactPlayer([{
  key: 'youtube',
  canPlay: Player.canPlay,
  lazyPlayer: Player
}]);

export { youtube as default };
//# sourceMappingURL=youtube.js.map
